// extracted by mini-css-extract-plugin
module.exports =  {"button":"_0d624b9a27--button--DsA7r"};